import { Link } from 'react-router';

export function AdministrationPage() {
  return (
    <section className="portal-section">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Administration</p>
          <h1>Administration</h1>
          <p className="hero-description">
            Manage portal resources and configuration.
          </p>
        </div>
      </div>
      <div className="feature-grid">
        <article className="feature-card">
          <h2>Telephone resources</h2>
          <p>Register Phonero credentials and block or activate telephones.</p>
          <Link className="secondary-button button-link" to="/admin/telephones">
            Manage telephones
          </Link>
        </article>
        <article className="feature-card">
          <h2>Caller display numbers</h2>
          <p>Map event labels to the outgoing numbers callers present.</p>
          <Link className="secondary-button button-link" to="/admin/display-numbers">
            Manage display numbers
          </Link>
        </article>
        <article className="feature-card">
          <h2>Users</h2>
          <p>Add Entra members and manage event-specific roles.</p>
          <Link className="secondary-button button-link" to="/admin/users">
            Manage users
          </Link>
        </article>
        <article className="feature-card">
          <h2>Events</h2>
          <p>Create, edit and close calling events.</p>
          <Link className="secondary-button button-link" to="/events">
            Manage events
          </Link>
        </article>
      </div>
    </section>
  );
}
